import { render, staticRenderFns } from "./Pitches.vue?vue&type=template&id=cd584a8c&scoped=true&lang=pug"
import script from "./Pitches.vue?vue&type=script&lang=js"
export * from "./Pitches.vue?vue&type=script&lang=js"
import style0 from "./Pitches.vue?vue&type=style&index=0&id=cd584a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd584a8c",
  null
  
)

export default component.exports